import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Loader2, ArrowLeft } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) navigate("/admin", { replace: true });
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) navigate("/admin", { replace: true });
    else setError(res.error);
  };

  const FIELD =
    "w-full bg-white border border-gold-subtle rounded-md text-navy font-body py-3 px-4 outline-none focus:border-barn focus:ring-1 focus:ring-barn/30 transition-[border-color,box-shadow] duration-300 placeholder:text-ink/40";

  return (
    <div className="min-h-screen bg-cream flex items-center justify-center px-5 relative">
      <div className="paper-grain" />
      <Link to="/" className="absolute top-6 left-6 flex items-center gap-2 text-ink hover:text-barn transition-colors font-body text-sm font-medium">
        <ArrowLeft size={16} /> Back to site
      </Link>
      <motion.div
        initial={{ opacity: 0, y: 22 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
        className="relative bg-white border border-gold-subtle rounded-lg p-8 sm:p-10 w-full max-w-md shadow-[0_30px_60px_-30px_rgba(26,37,48,0.3)]"
      >
        <span className="overline text-barn">Admin Access</span>
        <h1 className="mt-3 font-display text-3xl md:text-4xl text-navy">Lieber Sourcing</h1>
        <p className="font-body text-ink text-sm mt-2">Content management & analytics.</p>

        <form onSubmit={submit} className="mt-8 space-y-5" data-testid="login-form">
          <div>
            <label className="overline text-navy-soft block mb-2">Username</label>
            <input data-testid="login-email" type="text" autoCapitalize="none" autoCorrect="off" className={FIELD} value={email} onChange={(e) => setEmail(e.target.value)} placeholder="admin" />
          </div>
          <div>
            <label className="overline text-navy-soft block mb-2">Password</label>
            <input data-testid="login-password" type="password" className={FIELD} value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" />
          </div>
          {error && <div data-testid="login-error" className="font-body text-sm text-barn">{error}</div>}
          <button
            type="submit"
            disabled={loading}
            data-testid="login-submit"
            className="w-full font-body font-semibold text-sm px-6 py-4 bg-barn text-ivory rounded-md hover:bg-[#9c3227] transition-colors duration-300 flex items-center justify-center gap-2 disabled:opacity-60"
          >
            {loading ? <><Loader2 size={16} className="animate-spin" /> Signing in…</> : "Sign In"}
          </button>
        </form>
      </motion.div>
    </div>
  );
}
